import { createSelector } from '@reduxjs/toolkit';
import { RequestListState, requestAdapter } from 'components/pages/console/store/RequestListSlice';
import { ActionStatus } from 'store/ActionState';
import { RootState } from 'store/RootReducer';
import PagerState from 'store/PagerState';
import Request from 'gql/Request';

const selectSelf = (state: RootState): RequestListState => {
  return state.requestList;
};

const selectListRequestsState = createSelector(selectSelf, (state: RequestListState): ActionStatus => {
  return state.requestState.status;
});

const selectPagerState = createSelector(selectSelf, (state: RequestListState): PagerState => state.pagerState);

const selectRequests = createSelector(selectSelf, (state: RequestListState): Request[] => {
  return requestAdapter.getSelectors().selectAll(state.requests);
});

const RequestListSelectors = {
  selectListRequestsState,
  selectPagerState,
  selectRequests,
};

export default RequestListSelectors;
